export const SummaryCard = ({ label, value, icon, variant = 'default', testId }) => {
  const variants = {
    default: 'bg-white border-slate-200',
    cash: 'bg-emerald-50 border-emerald-200',
    card: 'bg-sky-50 border-sky-200'
  };

  return (
    <div
      data-testid={testId}
      className={`p-6 rounded-xl border shadow-sm flex flex-col gap-2 transition-all hover:shadow-md ${variants[variant]}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">{label}</span>
        {icon}
      </div>
      <div className="text-3xl font-bold font-mono tracking-tight text-slate-900">{value}</div>
    </div>
  );
};

export default SummaryCard;